import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useFinanceSettingsStore } from "../store";

export const updateApprover = ({ churchId, approverData, approverId }) => {
  return axios.patch(
    `/churches/${churchId}/approvers/${approverId}`,
    approverData
  );
};

export const useUpdateApprover = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeUpdateApproverModal =
    useFinanceSettingsStore.getState().closeUpdateApproverModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["approvers"]);
      setNotification({
        type: "success",
        message: "Approver updated successfully!"
      });
      closeUpdateApproverModal();
    },
    ...config,
    mutationFn: updateApprover
  });
};
